import { CountryService } from "../../services/models/country";
const moduleCountry = {
	namespaced: true,
	state: {
		countries: [],
		loading: false,
	},
	getters: {
		getCountries(state) {
			return state.countries;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadCountries(state, countries) {
			state.countries = countries;
		}
	},
	actions: {
		async loadCountries({ commit, state }) {
			state.loading = true;
			let countries = await CountryService.getAll();
			commit("loadCountries", countries);
			state.loading = false;
		}
	}
}

export default moduleCountry;